import { useContext } from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import { LangContext } from "../../App";

type BoarderCenterCardType = {
  title? : string;
  subtitle? : string;
  subtitleTwo? : string;
  subtitleThree? : string;
  icon? : {
    src : string;
    alt : string;
  }
}

const BorderCenterCard = ({ cards = [] } : { cards : BoarderCenterCardType[] }) => {
  const { lang } = useContext(LangContext);

  return (
    <div className={`border-center-card-container ${lang === 0 ? "" : "rtl"}`}>
      <div className="wrapper-small">
        <div className={`card-row ${cards.length === 1 ? "one" : cards.length === 2 ? "two" : "three"}`}>
          {
          cards.map((item, index) => (
            <ReactVisibilitySensor>
            {({isVisible} : any) => (
              <div className="card-col" key={index}>
                <div className={`side-one an-move-right-fade-in ${isVisible ? "an-active" : ""}`}>
                    {item.subtitleTwo ? <h2 className="subtitle-two">{item.subtitleTwo}</h2> : ""}
                </div>
                <div className={`side-two an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>
                  {item.icon ? <img src={item.icon.src} alt={item.icon.alt} className="icon" aria-hidden="true" /> : ""}
                  {item.subtitleThree ? <p className="subtitle-three">{item.subtitleThree}</p> : ""}
                  <div className="card-one-col">
                  {item.title ? <span className="title">{item.title}</span> : ""}
                  {item.subtitle ? <span className="subtitle">{item.subtitle}</span> : ""}
                  </div>
                </div>
              </div>
            )}
            </ReactVisibilitySensor>
          ))
          }
        </div>
      </div>
    </div>
  )
}

export default BorderCenterCard